<div class="flex gap-xs pb-xs">
  <core-icon class="text-content-state-error" icon="error"></core-icon>
  <h5>Technischer Fehler</h5>
</div>
<p class="body-md text-body-primary">
  Der Vorgang konnte nicht abgeschlossen werden. Bitte versuchen Sie es später erneut. Sollte das Problem weiterhin bestehen bleiben, wenden Sie sich bitte an den Technischen Support.
</p>
